module.exports = __webpack_public_path__ + "static/img/home_new11.1a5c38cf.jpg";